<div class="upgrade_agreement">
    <div class="top_panel">
      <h3>Renew Agreement</h3>
      <span (click)="close()" class="close">
        <img src="https://cdn.elitehw.com/images/cross.webp" />
      </span>
    </div>
    <div class="upgrade_body">
      <h3>
        <strong>{{agreementCalculationData?.planTitle}}</strong>
      </h3>
      <div class="inner_body">
        <div class="panel">
          <div class="left_side">
            <div class="white_panel">
              <div class="heading_payment">
                <h3>
                  Payment mode
                </h3>
                <div *ngIf="!oneTimePlan">
                  <span *ngIf="isInstallmentFormDisabled" (click)="toggleInstallmentDisabledForm(false)" class="edit_icon"><mat-icon>edit</mat-icon></span>
                  <span *ngIf="!isInstallmentFormDisabled" (click)="toggleInstallmentDisabledForm(true)" class="edit_icon"><mat-icon>check</mat-icon></span>
                </div>
              </div>
              
              <ng-container>
                <div class="option_payment">
                  <span (click)="togglePaymentType(true)" [ngClass]="{'active': oneTimePlan}">One Time Payment</span>
                  <span (click)="togglePaymentType(false)" [ngClass]="{'active': !oneTimePlan}" *ngIf="agreementDetails?.pricingOption !== 'Monthly'">Payment Plan</span>
                </div>
                <div *ngIf="!oneTimePlan">
                  <div class="installment_mode">
                     <form [formGroup]="installmentForm">
                      <mat-radio-group formControlName="paymentType">
                        <mat-radio-button *ngFor="let item of repeatArray(limitOfInstallment); index as i" [value]=" i + 1" (change)="radioChange($event)">{{installmentText(i+1)}}</mat-radio-button>
                      </mat-radio-group>
                     </form>
                  </div>
                    
                    <div class="payment_wrap" [ngClass]="{'step_two': installmentForm.get('paymentType').value !== 1}">
                      <div *ngIf="installmentForm.get('paymentType').value === 1">
                        <mat-form-field fxFlex="auto" appearance="outline">
                          <mat-label>Initial Paid Amount</mat-label>
                          <input matInput placeholder="Initial Paid Amount" mask="separator.2" thousandSeparator=","  prefix="$"  [(ngModel)]="oneTimeInstallmentPaymentPrice" disabled>
                        </mat-form-field>
                      </div>
                       <form [formGroup]="installmentForm">
                        <div class="renw_wrap">
                          <ng-container *ngIf="installmentForm.get('paymentType').value !== 1">
                            <mat-form-field fxFlex="auto" appearance="outline">
                              <mat-label>Initial Paid Amount</mat-label>
                              <input matInput placeholder="Initial Paid Amount"  mask="separator.2" thousandSeparator=","  prefix="$" formControlName="initialPaidAmount">
                            </mat-form-field>
                          </ng-container>
    
                          <mat-form-field appearance="outline">
                              <mat-label>Initial Payment Date</mat-label>
                              <input matInput [matDatepicker]="picker" (click)="picker.open()" readonly formControlName="initialPaymentDate" [min]="minData">
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                          
                          <mat-form-field appearance="outline" *ngIf="installmentForm.get('paymentType').value > 1">
                            <mat-label>Installment Payment Date</mat-label>
                              <input matInput formControlName="installmentPaymentDate" [matDatepicker]="picker1" (click)="picker1.open()" [readonly]="true" [min]="installmentMinDate">
                              <mat-datepicker-toggle matIconSuffix [for]="picker1" class="toggle_payment"></mat-datepicker-toggle>
                              <mat-datepicker #picker1></mat-datepicker>
                              <mat-error *ngIf="installmentForm.controls['installmentPaymentDate'].touched && installmentForm.controls['installmentPaymentDate'].hasError('required')">
                                This is required.
                              </mat-error>
                              <mat-error *ngIf="installmentForm.controls['installmentPaymentDate'].touched && installmentForm.controls['installmentPaymentDate'].hasError('min')">
                                Please select valid date.
                              </mat-error>
                          </mat-form-field>
                        </div>
                          
                      </form>
                    </div>
                    <div class="item_list" *ngIf="installmentForm.get('paymentType').value > 1">
                      <ul>
                        <li *ngFor="let item of upcomingPayments">
                          {{item?.dueDate | date : "MMM-dd-YYYY" }} - <b>{{item?.amountPaid | currency}}</b>
                        </li>
                      </ul>
                    </div>
                </div>
              </ng-container>
            </div>
  
          
            
          </div>
          
            <div class="right-side">
              <h3>
                Order summary
              </h3>
              <div class="scroll">
                <p>Agreement Price: <span>{{(agreementCalculationData?.agreementPrice || 0 | currency)}}</span></p>
                <p>Additional Price: <span>{{(agreementCalculationData?.additionalPrice || 0 | currency)}}</span></p>
                <p>Surcharge: <span>{{(agreementCalculationData?.surchargeAmount || 0 | currency)}}</span></p>
                <p>Reflected Copay Amount: <span>{{(agreementCalculationData?.reflectedCopayAmount || 0 | currency)}}</span></p>
                <p>Total Cost: <span>{{(agreementCalculationData?.totalAmount || 0 | currency)}}</span></p>
                <p><strong>Discount:</strong> <span>{{(agreementCalculationData?.discountedPrice || 0 | currency)}}</span></p>
                <p><strong>Sub total:</strong> <span>{{(agreementCalculationData?.subTotalAmount || 0 | currency)}}</span></p>
                <p>Premium Paid: <span>{{(agreementCalculationData?.premiumPaid || 0 | currency)}}</span></p>
                <p>Effective Term: <span>{{agreementCalculationData?.effectiveTerm}}</span></p>
              </div>
              
              <div class="total_savingprt">
                <p>Total savings: <span>{{(agreementCalculationData?.discountedPrice || 0) | currency}}</span></p>
              </div>
              
            </div>
        </div>
          <div class="refund_process payment_process" *ngIf="data?.calculationType === 'upgrade' || agreementCalculationData">
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
              <mat-tab label="Credit card">
                <form [formGroup]="cardDetailsForm">
                  <div class="card_detail">
                    <div class="card_panel full">
                      <label> Card Holder Name </label>
                      <span>
                        <input
                          type="text"
                          placeholder="Card Holder Name"
                          formControlName="cardHoldarName"
                          (keyup)="apiService.restrictSpace($event)"
                          (keypress)="apiService.restrictSpecialChar($event, true)"
                        />
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['cardHoldarName'].touched &&
                            cardDetailsForm.controls['cardHoldarName'].hasError(
                              'required'
                            )
                          "
                        >
                          This is required
                        </mat-error>
                      </span>
                    </div>
                    <div class="card_panel full">
                      <label> Card Number </label>
                      <span>
                        <input
                          type="text"
                          placeholder="**** **** **** ****"
                          formControlName="cardNumber"
                          [hiddenInput]="true"
                          [mask]="
                            cardType == 'American Express'
                              ? 'XXXX XXXXXX X0000'
                              : 'XXXX XXXX XXXX 0000'
                          "
                          (ngModelChange)="detectCardType($event)"
                        />
                        <span
                          *ngIf="cardType && cardType == 'Visa'"
                          class="cardlogo"
                        >
                          <img
                            src="https://cdn.elitehw.com/images/visa-card-logo.png"
                            alt=""
                          />
                        </span>
                        <span
                          *ngIf="cardType && cardType == 'Mastercard'"
                          class="cardlogo mastercard"
                        >
                          <img
                            src="https://cdn.elitehw.com/images/master-card.png"
                            alt=""
                          />
                        </span>
                        <span
                          *ngIf="cardType && cardType == 'American Express'"
                          class="cardlogo"
                        >
                          <img
                            src="https://cdn.elitehw.com/images/American-Express.png"
                            alt=""
                          />
                        </span>
                        <span
                          *ngIf="cardType && cardType == 'Discover'"
                          class="cardlogo"
                        >
                          <img
                            src="https://cdn.elitehw.com/images/discover.png"
                            alt=""
                          />
                        </span>
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['cardNumber'].touched &&
                            cardDetailsForm.controls['cardNumber'].hasError(
                              'required'
                            )
                          "
                        >
                          This is required
                        </mat-error>
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['cardNumber'].touched &&
                            cardDetailsForm.controls['cardNumber'].hasError(
                              'mask'
                            )
                          "
                        >
                          Enter Valid Card Number
                        </mat-error>
                      </span>
                    </div>
                    <div class="card_panel">
                      <label> Expiration Date </label>
                      <span>
                        <input
                          type="text"
                          placeholder="00/00"
                          formControlName="monthYear"
                          mask="00/00"
                          
                        />
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            )
                          "
                        >
                          This is required
                        </mat-error>
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['monthYear'].hasError(
                              'mask'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            )
                          "
                        >
                          Enter valid Expiry month and year.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            ) &&
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['expiryMonth'].hasError(
                              'max'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'mask'
                            ) &&
                            cardDetailsForm.controls['expiryYear'].valid
                          "
                        >
                          Enter Valid Expire Month.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            ) &&
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['expiryMonth'].hasError(
                              'min'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'mask'
                            )
                          "
                        >
                          Expiry Month value should be greater then 1.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            ) &&
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['expiryYear'].hasError(
                              'min'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'mask'
                            ) &&
                            cardDetailsForm.controls['expiryMonth'].valid
                          "
                        >
                          Enter Valid Expire Year.
                        </mat-error>
                        <mat-error
                          *ngIf="
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            ) &&
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['expiryMonth'].hasError(
                              'max'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'mask'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'required'
                            ) &&
                            cardDetailsForm.controls['monthYear'].touched &&
                            cardDetailsForm.controls['expiryYear'].hasError(
                              'min'
                            ) &&
                            !cardDetailsForm.controls['monthYear'].hasError(
                              'mask'
                            )
                          "
                        >
                          Enter valid expire month and year.
                        </mat-error>
                        <mat-error *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError('required') && 
                        cardDetailsForm.controls['expiryMonth'].hasError('notValid') && 
                        !cardDetailsForm.controls['monthYear'].hasError('mask') &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        !cardDetailsForm.controls['expiryYear'].hasError('min')">
                            Enter Valid Expire Month.
                      </mat-error>
                      </span>
                    </div>
                    <div class="card_panel">
                      <label> CVV </label>
                      <span>
                        <input
                          type="text"
                          placeholder="CVV"
                          formControlName="cvv"
                          [hiddenInput]="true"
                          [mask]="cardType == 'American Express' ? 'XXXX' : 'XXX'"
                        />
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['cvv'].touched &&
                            cardDetailsForm.controls['cvv'].hasError('required')
                          "
                        >
                          This is required
                        </mat-error>
                        <mat-error
                          *ngIf="
                            cardDetailsForm.controls['cvv'].touched &&
                            cardDetailsForm.controls['cvv'].hasError('mask')
                          "
                        >
                          Enter valid cvv code.
                        </mat-error>
                      </span>
                    </div>
                  </div>
                </form>
              </mat-tab>
              <mat-tab label="Bank" *ngIf="data?.calculationType === 'upgrade' || !agreementCalculationData?.refundableToOriginalPaymentSource">
                <form [formGroup]="bankDetailsForm">
                  <div class="card_detail">
                    <div class="card_panel full">
                      <label> Account Holder Name </label>
                      <span>
                        <input
                          type="text"
                          placeholder="Account Holder Name"
                          formControlName="nameOnAccount"
                          (keyup)="apiService.restrictSpace($event)"
                          (keypress)="apiService.restrictSpecialChar($event, true)"
                        />
                        <mat-error
                          *ngIf="
                            bankDetailsForm.controls['nameOnAccount'].touched &&
                            bankDetailsForm.controls['nameOnAccount'].hasError(
                              'required'
                            )
                          "
                        >
                          This is required
                        </mat-error>
                        <mat-error
                          *ngIf="
                            bankDetailsForm.controls['nameOnAccount'].touched &&
                            bankDetailsForm.controls['nameOnAccount'].hasError(
                              'minlength'
                            )
                          "
                        >
                          Name must be minimum 2 digits
                        </mat-error>
                      </span>
                    </div>
                    <div class="card_panel full">
                      <label> Account Number </label>
                      <span>
                        <input
                          type="text"
                          placeholder="**** **** **** ****"
                          mask="0000*"
                          minlength="4"
                          formControlName="accountNumber"
                        />
                        <mat-error
                          *ngIf="
                            bankDetailsForm.controls['accountNumber'].touched &&
                            bankDetailsForm.controls['accountNumber'].hasError(
                              'required'
                            )
                          "
                        >
                          This is required
                        </mat-error>
                        <mat-error
                          *ngIf="
                            bankDetailsForm.controls['accountNumber'].touched &&
                            bankDetailsForm.controls['accountNumber'].hasError(
                              'minlength'
                            )
                          "
                        >
                          Account Number must be minimum 4 digits.
                        </mat-error>
                      </span>
                    </div>
                    <div class="cardflex">
                      <div class="card_panel">
                        <label>Routing No </label>
                        <span>
                          <input
                            type="text"
                            placeholder="Routing No"
                            formControlName="routingNumber"
                            mask="000000000"
                            (ngModelChange)="getBankDetail()"
                          />
                          <mat-error
                            *ngIf="
                              bankDetailsForm.controls['routingNumber'].touched &&
                              bankDetailsForm.controls['routingNumber'].hasError(
                                'required'
                              )
                            "
                          >
                            This is required
                          </mat-error>
                          <mat-error
                            *ngIf="
                              bankDetailsForm.controls['routingNumber'].touched &&
                              (bankDetailsForm.controls['routingNumber'].hasError(
                                'minlength'
                              ) ||
                                bankDetailsForm.controls['routingNumber'].hasError(
                                  'maxlength'
                                ))
                            "
                          >
                            Routing Number must be 9 digits.
                          </mat-error>
                        </span>
                      </div>
                      <div class="card_panel">
                        <label>Bank Name </label>
                        <span>
                          <input
                            type="text"
                            placeholder="Bank Name"
                            formControlName="bankName"
                            disabled
                          />
                          <mat-error
                            *ngIf="
                              bankDetailsForm.controls['bankName'].touched &&
                              bankDetailsForm.controls['bankName'].hasError(
                                'required'
                              )
                            "
                          >
                            This is required
                          </mat-error>
                        </span>
                      </div>
                      <div class="card_panel">
                        <label> Transaction Number </label>
                        <span>
                          <input
                            type="text"
                            placeholder="Transaction Number"
                            formControlName="transactionNumber"
                          />
                          <mat-error
                            *ngIf="
                              bankDetailsForm.controls['transactionNumber']
                                .touched &&
                              bankDetailsForm.controls[
                                'transactionNumber'
                              ].hasError('required')
                            "
                          >
                            This is required
                          </mat-error>
                        </span>
                      </div>
                    </div>
                    
                  </div>
                </form>
              </mat-tab>
            </mat-tab-group>
          </div>
  
  
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button mat-button type="button" class="sub-button" (click)="checkPaymentForm()" [disabled]="!isInstallmentFormDisabled" *ngIf="!isLoading"><span>Renew Agreement</span></button>
            <img [src]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
            <button mat-button type="button" class="can-button" (click)="close()" *ngIf="!isLoading"><span>Cancel</span></button>
          </div>
      </div>
    </div>
      
  </div>
  